var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useEventListener, uuid } from "..";
export const MarkerCanvas = React.memo(function MarkerCanvas(_a) {
    var { edit } = _a, props = __rest(_a, ["edit"]);
    if (edit) {
        return React.createElement(ImageEdit, Object.assign({}, props));
    }
    return React.createElement(ImageRender, Object.assign({}, props));
});
function ImageEdit({ width, height, imageWidth, imageHeight, imageUrl, markers, onCreateMarker: createMarker, onUpdateMarkerPosition: updateMarker, onMarkerDoubleClick, }) {
    const mouseposition = React.useRef([0, 0]);
    const annotationDrag = React.useRef(null);
    const imageContainerRef = React.useRef(null);
    const scale = width / imageWidth;
    const calculatePosition = () => {
        if (!imageContainerRef.current) {
            return [0, 0];
        }
        const [mouseX, mouseY] = mouseposition.current;
        const maxX = imageWidth;
        const maxY = imageHeight;
        const viewportOffset = imageContainerRef.current.getBoundingClientRect();
        const offsetTop = viewportOffset.top;
        const offsetLeft = viewportOffset.left;
        let x = (mouseX - offsetLeft - 15) / scale;
        let y = (mouseY - offsetTop - 15) / scale;
        x = Math.round(x / 10) * 10;
        y = Math.round(y / 10) * 10;
        x = Math.round(Math.max(0, Math.min(x, maxX)));
        y = Math.round(Math.max(0, Math.min(y, maxY)));
        return [x, y];
    };
    useEventListener("mousemove", (e) => {
        mouseposition.current = [e.clientX, e.clientY];
        if (annotationDrag.current !== null) {
            // drag
            const [x, y] = calculatePosition();
            const left = Math.round(x * scale);
            const top = Math.round(y * scale);
            const [, element] = annotationDrag.current;
            element.style.top = top + "px";
            element.style.left = left + "px";
        }
    });
    useEventListener("mouseup", (e) => {
        if (annotationDrag.current !== null) {
            const [x, y] = calculatePosition();
            const [index] = annotationDrag.current;
            updateMarker(index, x, y);
        }
        annotationDrag.current = null;
    });
    return (React.createElement("div", { ref: imageContainerRef, style: {
            width,
            height,
            position: "relative",
            userSelect: "none",
        } },
        React.createElement("img", { src: imageUrl, style: {
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
                width,
                height: Math.round(imageHeight * scale),
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 2,
                width,
                height,
            }, onClick: (e) => {
                const key = uuid();
                const [x, y] = calculatePosition();
                createMarker(key, x, y);
            } }),
        Object.entries(markers).map(([key, marker]) => marker.render({
            key: key,
            style: {
                position: "absolute",
                left: Math.round(marker.x * scale) + "px",
                top: Math.round(marker.y * scale) + "px",
                zIndex: 3,
            },
            onClick: (e) => {
                if (e.detail === 2) {
                    // on dubble klick
                    onMarkerDoubleClick(key);
                }
            },
            onMouseDown: (e) => {
                // drag start
                annotationDrag.current = [key, e.target];
            },
        }))));
}
function ImageRender({ width, height, imageWidth, imageHeight, imageUrl, markers, }) {
    const scale = width / imageWidth;
    return (React.createElement("div", { style: {
            width,
            height,
            position: "relative",
        } },
        React.createElement("img", { src: imageUrl, style: {
                width,
                height: Math.round(imageHeight * scale),
            } }),
        Object.entries(markers).map(([key, marker]) => marker.render({
            key: key,
            style: {
                position: "absolute",
                left: Math.round(marker.x * scale) + "px",
                top: Math.round(marker.y * scale) + "px",
            },
        }))));
}
//# sourceMappingURL=MarkerCanvas.js.map